// Copy for presence (docs/design/social-plan.md, phase 5): the "open to taste together" label, the
// relative last-active line and the settings switch. One entry per locale; every key exists in all
// seven (nl is the source, the rest are translations). The relative times themselves come from
// Intl.RelativeTimeFormat, so only "just now" and the lines around them are copy.
export const presenceCopy = {
  nl: {
    "social.presence.justNow": "zojuist",
    "social.presence.open": "Open om samen te proeven",
    "social.presence.session": "Straks een proeverij",
    "social.presence.lastActive": "Actief {when}",
    "social.presence.title": "Open om samen te proeven",
    "social.presence.switch": "Laat zien wanneer ik open sta voor een proeverij",
    "social.presence.hint":
      "Vrienden en groepsleden zien je als open zolang proef openstaat en 4 uur daarna, en rond proeverijen waar je ja op zei. Ze zien ook wanneer je voor het laatst actief was. Uit betekent: er wordt niets bewaard en niets getoond.",
    "social.presence.profile.on":
      "Vrienden en groepen zien wanneer je open staat om samen te proeven.",
    "social.presence.profile.off":
      "Je staat niet als open te zien; je kunt dat in de instellingen aanzetten.",
    "social.presence.error": "De schakelaar bleef staan zoals hij was.",
    "social.presence.sessionLive": "In een lopende proeverij",
    "social.presence.sessionAfter": "Net een proeverij gehad",
    "social.presence.tasting": "Aan het proeven",
    "social.presence.tastingAt": "Aan het proeven: {name}",
    "social.presence.tastingStep": "{base} · {step}",
    "social.presence.step.look": "bij Uiterlijk",
    "social.presence.step.smell": "bij Neus",
    "social.presence.step.taste": "bij Smaak",
    "social.presence.step.structure": "bij Structuur",
    "social.presence.step.summary": "bij de afronding",
    "social.presence.join": "Doe mee",
    "social.presence.joinLabel": "Doe mee met {name}",
    "social.presence.nowTitle": "Aan het proeven",
    "social.presence.nowMore": "en {n} anderen",
    "social.presence.lobby.online": "Online: {names}",
    "social.presence.sessionPeople": "{n} nu aan het proeven",
    "social.presence.tastingHint":
      "Vrienden en groepsleden zien ook dat je aan het proeven bent. Proef je alleen, dan zien ze alleen dat, zonder wijn of naam. Bij een gedeelde proeverij zien ze de naam ervan en waar je bent. Het verdwijnt als je klaar bent, na 4 uur, of als proef dicht is.",
    "social.groups.log.session.planned": "{name} plande {session}",
    "social.groups.log.session.rsvp": "{name} doet mee met {session}",
    "social.groups.log.session.started": "{name} startte {session}",
    "social.groups.log.session.result":
      "{session} is afgerond: {wines} wijnen, {people} deelnemers",
    "social.groups.log.session.live": "{name} proeft nu {session}",
    "social.notify.activity": "Vrienden die aan het proeven zijn",
    "social.notify.activity.hint":
      "Een melding als een vriend of groepslid een gedeelde proeverij begint, of een wijn op de lijst van een groep zet. Standaard uit; stille uren, dempingen en het daglimiet gelden ook hier.",
    "social.person.cards": "Kaarten",
  },
  en: {
    "social.presence.justNow": "just now",
    "social.presence.open": "Open to taste together",
    "social.presence.session": "Tasting coming up",
    "social.presence.lastActive": "Active {when}",
    "social.presence.title": "Open to taste together",
    "social.presence.switch": "Show when I am open to taste together",
    "social.presence.hint":
      "Friends and group members see you as open while proef is open and for 4 hours after, and around tastings you said yes to. They also see when you were last active. Off means nothing is stored and nothing is shown.",
    "social.presence.profile.on": "Friends and groups see when you are open to taste together.",
    "social.presence.profile.off": "You do not show as open; you can turn that on in settings.",
    "social.presence.error": "The switch stayed as it was.",
    "social.presence.sessionLive": "In a tasting that is running",
    "social.presence.sessionAfter": "Just had a tasting",
    "social.presence.tasting": "Tasting now",
    "social.presence.tastingAt": "Tasting now: {name}",
    "social.presence.tastingStep": "{base} · {step}",
    "social.presence.step.look": "at Appearance",
    "social.presence.step.smell": "at Nose",
    "social.presence.step.taste": "at Palate",
    "social.presence.step.structure": "at Structure",
    "social.presence.step.summary": "at the wrap-up",
    "social.presence.join": "Join",
    "social.presence.joinLabel": "Join {name}",
    "social.presence.nowTitle": "Tasting now",
    "social.presence.nowMore": "and {n} others",
    "social.presence.lobby.online": "Online: {names}",
    "social.presence.sessionPeople": "{n} tasting now",
    "social.presence.tastingHint":
      "Friends and group members also see that you are tasting. Tasting alone, they only see that, with no wine and no name. In a shared tasting they see its name and where you are. It goes when you finish, after 4 hours, or when proef is closed.",
    "social.groups.log.session.planned": "{name} planned {session}",
    "social.groups.log.session.rsvp": "{name} is joining {session}",
    "social.groups.log.session.started": "{name} started {session}",
    "social.groups.log.session.result": "{session} wrapped up: {wines} wines, {people} people",
    "social.groups.log.session.live": "{name} is tasting {session} now",
    "social.notify.activity": "Friends who are tasting",
    "social.notify.activity.hint":
      "A notification when a friend or group member starts a shared tasting, or puts a wine on a group's list. Off by default; quiet hours, mutes and the daily limit apply here too.",
    "social.person.cards": "Cards",
  },
  de: {
    "social.presence.justNow": "gerade eben",
    "social.presence.open": "Offen für eine gemeinsame Verkostung",
    "social.presence.session": "Bald eine Verkostung",
    "social.presence.lastActive": "Aktiv {when}",
    "social.presence.title": "Offen für eine gemeinsame Verkostung",
    "social.presence.switch": "Zeigen, wann ich für eine Verkostung offen bin",
    "social.presence.hint":
      "Freunde und Gruppenmitglieder sehen dich als offen, solange proef geöffnet ist und 4 Stunden danach, sowie rund um Verkostungen, denen du zugesagt hast. Sie sehen auch, wann du zuletzt aktiv warst. Aus bedeutet: Nichts wird gespeichert und nichts angezeigt.",
    "social.presence.profile.on":
      "Freunde und Gruppen sehen, wann du für eine gemeinsame Verkostung offen bist.",
    "social.presence.profile.off":
      "Du erscheinst nicht als offen; du kannst das in den Einstellungen einschalten.",
    "social.presence.error": "Der Schalter blieb, wie er war.",
    "social.presence.sessionLive": "In einer laufenden Verkostung",
    "social.presence.sessionAfter": "Gerade eine Verkostung gehabt",
    "social.presence.tasting": "Verkostet gerade",
    "social.presence.tastingAt": "Verkostet gerade: {name}",
    "social.presence.tastingStep": "{base} · {step}",
    "social.presence.step.look": "beim Aussehen",
    "social.presence.step.smell": "bei der Nase",
    "social.presence.step.taste": "beim Geschmack",
    "social.presence.step.structure": "bei der Struktur",
    "social.presence.step.summary": "beim Abschluss",
    "social.presence.join": "Mitmachen",
    "social.presence.joinLabel": "Bei {name} mitmachen",
    "social.presence.nowTitle": "Verkostet gerade",
    "social.presence.nowMore": "und {n} weitere",
    "social.presence.lobby.online": "Online: {names}",
    "social.presence.sessionPeople": "{n} verkosten gerade",
    "social.presence.tastingHint":
      "Freunde und Gruppenmitglieder sehen auch, dass du gerade verkostest. Allein sehen sie nur das, ohne Wein und ohne Namen. Bei einer gemeinsamen Verkostung sehen sie deren Namen und wo du bist. Es verschwindet, wenn du fertig bist, nach 4 Stunden oder wenn proef geschlossen ist.",
    "social.groups.log.session.planned": "{name} hat {session} geplant",
    "social.groups.log.session.rsvp": "{name} macht bei {session} mit",
    "social.groups.log.session.started": "{name} hat {session} gestartet",
    "social.groups.log.session.result":
      "{session} ist abgeschlossen: {wines} Weine, {people} Teilnehmende",
    "social.groups.log.session.live": "{name} verkostet gerade bei {session}",
    "social.notify.activity": "Freunde, die gerade verkosten",
    "social.notify.activity.hint":
      "Eine Meldung, wenn ein Freund oder Gruppenmitglied eine gemeinsame Verkostung beginnt oder einen Wein auf die Liste einer Gruppe setzt. Standardmäßig aus; ruhige Stunden, Stummschaltungen und das Tageslimit gelten auch hier.",
    "social.person.cards": "Karten",
  },
  fr: {
    "social.presence.justNow": "à l'instant",
    "social.presence.open": "Ouvert pour déguster ensemble",
    "social.presence.session": "Une dégustation approche",
    "social.presence.lastActive": "Actif {when}",
    "social.presence.title": "Ouvert pour déguster ensemble",
    "social.presence.switch": "Montrer quand je suis ouvert pour une dégustation",
    "social.presence.hint":
      "Vos amis et les membres de vos groupes vous voient ouvert tant que proef est ouvert et pendant 4 heures après, ainsi qu'autour des dégustations auxquelles vous avez dit oui. Ils voient aussi votre dernière activité. Désactivé : rien n'est enregistré ni affiché.",
    "social.presence.profile.on":
      "Vos amis et groupes voient quand vous êtes ouvert pour déguster ensemble.",
    "social.presence.profile.off":
      "Vous n'apparaissez pas comme ouvert ; vous pouvez l'activer dans les réglages.",
    "social.presence.error": "L'interrupteur est resté tel quel.",
    "social.presence.sessionLive": "Dans une dégustation en cours",
    "social.presence.sessionAfter": "Vient de déguster",
    "social.presence.tasting": "Déguste en ce moment",
    "social.presence.tastingAt": "Déguste en ce moment : {name}",
    "social.presence.tastingStep": "{base} · {step}",
    "social.presence.step.look": "à l'aspect",
    "social.presence.step.smell": "au nez",
    "social.presence.step.taste": "en bouche",
    "social.presence.step.structure": "à la structure",
    "social.presence.step.summary": "au bilan",
    "social.presence.join": "Rejoindre",
    "social.presence.joinLabel": "Rejoindre {name}",
    "social.presence.nowTitle": "Déguste en ce moment",
    "social.presence.nowMore": "et {n} autres",
    "social.presence.lobby.online": "En ligne : {names}",
    "social.presence.sessionPeople": "{n} dégustent en ce moment",
    "social.presence.tastingHint":
      "Vos amis et les membres de vos groupes voient aussi que vous dégustez. Seul, ils voient seulement cela, sans vin ni nom. Dans une dégustation partagée, ils voient son nom et où vous en êtes. Cela disparaît quand vous avez fini, après 4 heures, ou quand proef est fermé.",
    "social.groups.log.session.planned": "{name} a prévu {session}",
    "social.groups.log.session.rsvp": "{name} participe à {session}",
    "social.groups.log.session.started": "{name} a lancé {session}",
    "social.groups.log.session.result": "{session} est terminée : {wines} vins, {people} personnes",
    "social.groups.log.session.live": "{name} déguste maintenant {session}",
    "social.notify.activity": "Amis qui dégustent",
    "social.notify.activity.hint":
      "Une notification quand un ami ou un membre d'un groupe commence une dégustation partagée ou ajoute un vin à la liste d'un groupe. Désactivé par défaut ; les heures calmes, les sourdines et la limite quotidienne s'appliquent aussi.",
    "social.person.cards": "Cartes",
  },
  es: {
    "social.presence.justNow": "ahora mismo",
    "social.presence.open": "Abierto a catar juntos",
    "social.presence.session": "Pronto una cata",
    "social.presence.lastActive": "Activo {when}",
    "social.presence.title": "Abierto a catar juntos",
    "social.presence.switch": "Mostrar cuándo estoy abierto a una cata",
    "social.presence.hint":
      "Tus amigos y los miembros de tus grupos te ven abierto mientras proef está abierto y 4 horas después, y alrededor de las catas a las que dijiste que sí. También ven cuándo estuviste activo por última vez. Desactivado: no se guarda ni se muestra nada.",
    "social.presence.profile.on": "Tus amigos y grupos ven cuándo estás abierto a catar juntos.",
    "social.presence.profile.off": "No apareces como abierto; puedes activarlo en los ajustes.",
    "social.presence.error": "El interruptor se quedó como estaba.",
    "social.presence.sessionLive": "En una cata en curso",
    "social.presence.sessionAfter": "Acaba de tener una cata",
    "social.presence.tasting": "Catando ahora",
    "social.presence.tastingAt": "Catando ahora: {name}",
    "social.presence.tastingStep": "{base} · {step}",
    "social.presence.step.look": "en la vista",
    "social.presence.step.smell": "en la nariz",
    "social.presence.step.taste": "en la boca",
    "social.presence.step.structure": "en la estructura",
    "social.presence.step.summary": "en el resumen",
    "social.presence.join": "Unirse",
    "social.presence.joinLabel": "Unirse a {name}",
    "social.presence.nowTitle": "Catando ahora",
    "social.presence.nowMore": "y {n} más",
    "social.presence.lobby.online": "En línea: {names}",
    "social.presence.sessionPeople": "{n} catando ahora",
    "social.presence.tastingHint":
      "Tus amigos y los miembros de tus grupos también ven que estás catando. Si catas solo, solo ven eso, sin vino ni nombre. En una cata compartida ven su nombre y dónde vas. Desaparece cuando terminas, a las 4 horas o cuando proef está cerrado.",
    "social.groups.log.session.planned": "{name} planificó {session}",
    "social.groups.log.session.rsvp": "{name} se une a {session}",
    "social.groups.log.session.started": "{name} empezó {session}",
    "social.groups.log.session.result": "{session} terminó: {wines} vinos, {people} personas",
    "social.groups.log.session.live": "{name} está catando {session} ahora",
    "social.notify.activity": "Amigos que están catando",
    "social.notify.activity.hint":
      "Un aviso cuando un amigo o miembro de un grupo empieza una cata compartida o añade un vino a la lista de un grupo. Desactivado por defecto; las horas de silencio, los silencios y el límite diario también valen aquí.",
    "social.person.cards": "Tarjetas",
  },
  it: {
    "social.presence.justNow": "proprio ora",
    "social.presence.open": "Aperto a degustare insieme",
    "social.presence.session": "Presto una degustazione",
    "social.presence.lastActive": "Attivo {when}",
    "social.presence.title": "Aperto a degustare insieme",
    "social.presence.switch": "Mostra quando sono aperto a una degustazione",
    "social.presence.hint":
      "Amici e membri dei tuoi gruppi ti vedono aperto finché proef è aperto e per 4 ore dopo, e attorno alle degustazioni a cui hai detto sì. Vedono anche quando sei stato attivo l'ultima volta. Disattivato: non viene salvato né mostrato nulla.",
    "social.presence.profile.on": "Amici e gruppi vedono quando sei aperto a degustare insieme.",
    "social.presence.profile.off": "Non risulti aperto; puoi attivarlo nelle impostazioni.",
    "social.presence.error": "L'interruttore è rimasto com'era.",
    "social.presence.sessionLive": "In una degustazione in corso",
    "social.presence.sessionAfter": "Ha appena fatto una degustazione",
    "social.presence.tasting": "Sta degustando",
    "social.presence.tastingAt": "Sta degustando: {name}",
    "social.presence.tastingStep": "{base} · {step}",
    "social.presence.step.look": "all'aspetto",
    "social.presence.step.smell": "al naso",
    "social.presence.step.taste": "al palato",
    "social.presence.step.structure": "alla struttura",
    "social.presence.step.summary": "al riepilogo",
    "social.presence.join": "Partecipa",
    "social.presence.joinLabel": "Partecipa a {name}",
    "social.presence.nowTitle": "Sta degustando",
    "social.presence.nowMore": "e altri {n}",
    "social.presence.lobby.online": "Online: {names}",
    "social.presence.sessionPeople": "{n} stanno degustando",
    "social.presence.tastingHint":
      "Amici e membri dei tuoi gruppi vedono anche che stai degustando. Se degusti da solo, vedono solo questo, senza vino né nome. In una degustazione condivisa vedono il nome e a che punto sei. Sparisce quando finisci, dopo 4 ore o quando proef è chiuso.",
    "social.groups.log.session.planned": "{name} ha pianificato {session}",
    "social.groups.log.session.rsvp": "{name} partecipa a {session}",
    "social.groups.log.session.started": "{name} ha avviato {session}",
    "social.groups.log.session.result": "{session} è finita: {wines} vini, {people} persone",
    "social.groups.log.session.live": "{name} sta degustando {session} ora",
    "social.notify.activity": "Amici che stanno degustando",
    "social.notify.activity.hint":
      "Una notifica quando un amico o un membro di un gruppo inizia una degustazione condivisa o aggiunge un vino alla lista di un gruppo. Disattivata di default; valgono anche ore silenziose, silenziamenti e limite giornaliero.",
    "social.person.cards": "Carte",
  },
  pt: {
    "social.presence.justNow": "agora mesmo",
    "social.presence.open": "Aberto para provar juntos",
    "social.presence.session": "Em breve uma prova",
    "social.presence.lastActive": "Ativo {when}",
    "social.presence.title": "Aberto para provar juntos",
    "social.presence.switch": "Mostrar quando estou aberto a uma prova",
    "social.presence.hint":
      "Amigos e membros dos teus grupos veem-te como aberto enquanto o proef estiver aberto e durante 4 horas depois, e em volta das provas a que disseste que sim. Também veem quando estiveste ativo pela última vez. Desligado: nada é guardado nem mostrado.",
    "social.presence.profile.on": "Amigos e grupos veem quando estás aberto para provar juntos.",
    "social.presence.profile.off": "Não apareces como aberto; podes ativar isso nas definições.",
    "social.presence.error": "O interruptor ficou como estava.",
    "social.presence.sessionLive": "Numa prova a decorrer",
    "social.presence.sessionAfter": "Acabou de ter uma prova",
    "social.presence.tasting": "A provar agora",
    "social.presence.tastingAt": "A provar agora: {name}",
    "social.presence.tastingStep": "{base} · {step}",
    "social.presence.step.look": "na aparência",
    "social.presence.step.smell": "no nariz",
    "social.presence.step.taste": "na boca",
    "social.presence.step.structure": "na estrutura",
    "social.presence.step.summary": "no resumo",
    "social.presence.join": "Juntar-me",
    "social.presence.joinLabel": "Juntar-me a {name}",
    "social.presence.nowTitle": "A provar agora",
    "social.presence.nowMore": "e mais {n}",
    "social.presence.lobby.online": "Online: {names}",
    "social.presence.sessionPeople": "{n} a provar agora",
    "social.presence.tastingHint":
      "Amigos e membros dos teus grupos também veem que estás a provar. A provar sozinho, só veem isso, sem vinho nem nome. Numa prova partilhada veem o nome e onde estás. Desaparece quando acabas, às 4 horas ou quando o proef está fechado.",
    "social.groups.log.session.planned": "{name} planeou {session}",
    "social.groups.log.session.rsvp": "{name} vai a {session}",
    "social.groups.log.session.started": "{name} começou {session}",
    "social.groups.log.session.result": "{session} terminou: {wines} vinhos, {people} pessoas",
    "social.groups.log.session.live": "{name} está a provar {session} agora",
    "social.notify.activity": "Amigos que estão a provar",
    "social.notify.activity.hint":
      "Um aviso quando um amigo ou membro de um grupo começa uma prova partilhada ou põe um vinho na lista de um grupo. Desligado por defeito; as horas de silêncio, os silenciamentos e o limite diário também se aplicam.",
    "social.person.cards": "Cartões",
  },
} as const;
